import { createContext, useContext } from 'react';
import { EMPTY_LOOKUPS } from './useAppBoot.js';

export const LookupsContext = createContext(EMPTY_LOOKUPS);

export function useLookups() {
  return useContext(LookupsContext);
}
